/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributeDocumentsRequest
 */
export interface DistributeDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof DistributeDocumentsRequest
     */
    taskId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DistributeDocumentsRequest
     */
    documentUids?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DistributeDocumentsRequest
     */
    language?: string;
}

/**
 * Check if a given object implements the DistributeDocumentsRequest interface.
 */
export function instanceOfDistributeDocumentsRequest(value: object): value is DistributeDocumentsRequest {
    return true;
}

export function DistributeDocumentsRequestFromJSON(json: any): DistributeDocumentsRequest {
    return DistributeDocumentsRequestFromJSONTyped(json, false);
}

export function DistributeDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributeDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'documentUids': json['documentUids'] == null ? undefined : json['documentUids'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function DistributeDocumentsRequestToJSON(json: any): DistributeDocumentsRequest {
    return DistributeDocumentsRequestToJSONTyped(json, false);
}

export function DistributeDocumentsRequestToJSONTyped(value?: DistributeDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'documentUids': value['documentUids'],
        'language': value['language'],
    };
}

